export class RedirectParameter {
    public name: string;
    public value: string;

    constructor(name, value){
        this.name = name;
        this.value = value;
    }
}